import { useEffect, useState } from "react";
import styles from "./ServiceDetailsForm.module.scss";
import { Storage } from "aws-amplify";
import { Info } from 'react-feather';


export default function ServiceDetailsForm(props) {

    const service = props.service;
    const isService = props.isService


    const [imgURL, setImgURL] = useState('');

    useEffect(async () => {

        if (service.id) {
            const id = service.id;
            const serviceName = service.value.trim().replaceAll(/[^a-zA-Z0-9 -_]/g, '').replaceAll(' ', '_');

            try {
                let url = ''
                if (isService) {
                    url = await Storage.get(`services/${id}_${serviceName}.svg`);
                } else {
                    url = await Storage.get(`credentials/${id}_${serviceName}.png`);
                }
                setImgURL(url);
            } catch (e) {
                console.error(e);
            }
        }

    }, [service])


    return (
        <>
            <div className={styles.serviceContainer}>
                <div className={styles.serviceImg}><img loading="lazy" src={imgURL} alt="service_img"></img></div>
                <div className={styles.serviceName}>{service.value} {isService ? `` : `(${service.acronym})`}</div>
                {isService && <div className={styles.serviceDescription}>{service.description}</div>}
                {!isService &&
                    <>
                        <div className={styles.quckFactContainer}>
                            <Info size={20} color={`var(--adfi_green500)`} /> <span>{service.quickFact}</span>
                        </div>
                        <div className={styles.detailsContainer}>
                            <span className={styles.descriptionHeader}>Description:</span>
                            <div>
                                {service.description}
                            </div>
                        </div>
                        <div className={styles.detailsContainer}>
                            <span className={styles.descriptionHeader}>Requirements:</span>
                            <div>
                                {service.requirements}
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    )
}
